
import { Injectable, Optional } from "@angular/core";
import { DwActionHandler, DwModalService, DwMenuService, DwMetaDataGridActionState, DwActionResult, DwAction, DwActionType, DwModalConfig, DwImportMetaDataModalComponent, DwModalButtonStandardConfigs, DwGridActionResult, DwRoutingService, DwModalSize, ensureArray, DwMetaDataFormStateService, DwMetaDataFormApi, DwEventService, DwGridEvents, DwMetaDataRoutingService, DwMenuActionType, DwModalResult } from "@devwareapps/devware-cap";
import { Observable, of } from "rxjs";
import { AppMetaData, AppMetaDataItemNames, AssignmentEntity, AssignmentStudentEntity, StudentEntity } from "../../../meta-data/app-meta-data.service";
import { map, mergeMap } from "rxjs/operators";
import { CourseProgressVariableContext } from "../../courses/models/course-progress-variable-context.model";
import { StudentAssignmentProgressEvent, studentAssignmentProgress } from "../models/student-assignment-progress-event.model";
import { StudentRepositoryService } from "../../students/services/student-repository.service";

@DwAction({
    keyName: 'assignment-student-add-modal-action',
    display: 'Assignment Student - Add Modal',
    actionType: DwActionType.gridAction,
    parentItemName: AppMetaDataItemNames.Student,
    isGlobal: false,
    defaultButtonConfig: {
        useParentDisplay: false,
        buttonText: 'Add',
        iconClass: 'fa fa-plus-circle',
        buttonClass: 'btn btn-success',
        buttonTitle: 'Add Assignment for Student'
    },
    defaultSecurityConfig: {
        requireAuthentication: true,
        useEmulatedPermissions: true,
    }
})
@Injectable()
export class AssignmentStudentAddModalService implements DwActionHandler {
    formApi: DwMetaDataFormApi;

    constructor(
        private dwModalService: DwModalService,
        private dwMenuService: DwMenuService,
        private dwRoutingService: DwRoutingService,
        private dwMetaDataRoutingService: DwMetaDataRoutingService,
        @Optional() private dwFormStateService: DwMetaDataFormStateService,
        private dwEventService: DwEventService,
        private studentRepositoryService: StudentRepositoryService
    ) {
        this.formApi = this.dwFormStateService?.state?.formApi;
    }

    handleAction(actionState: DwMetaDataGridActionState<any>): Observable<DwActionResult> {

        const userId: number = actionState.metaDataGridApi.addContext?.UserId;

        // Retrieve student id from user id
        return this.studentRepositoryService.getStudentFromUserId(userId).pipe(
            mergeMap(student => {
                return this.showAssignmentModal(student)
                    .pipe(map(addResult => {
                        const result: DwGridActionResult = {
                            success: !addResult.cancelled,
                            cancelled: addResult.cancelled,
                            refreshData: !addResult.cancelled
                        };

                        return result;
                    }));
            })
        )
    }


    showAssignmentModal(student: Partial<StudentEntity>): Observable<DwModalResult> {

        const addContext: any = {
            AssignmentStudent: [{
                StudentId: student.StudentId
            } as AssignmentStudentEntity
            ],
            StudentId: student.StudentId // This is assigned to a variable and used to show a single select student instead of the multi-select
        };

        const modalOptions = new DwModalConfig<any>();

        modalOptions.title = 'Add Assignment for Student';
        modalOptions.modalSize = DwModalSize.custom;
        modalOptions.customModalHeight = '760px';
        modalOptions.customModalWidth = '700px';
        modalOptions.allowFullScreen = false;
        modalOptions.hideFooter = true;

        modalOptions.buttons = [];
        

        return this.dwMetaDataRoutingService.openAddEditViewModal(DwMenuActionType.add, AppMetaDataItemNames.Assignment, null, addContext, null, 'flight-school-add-modal', modalOptions, true);

    }

}